import React from 'react';
import { Toaster } from '@/components/ui/toaster';

/**
 * Minimal shell for embedded surfaces (e.g. Twitch Extensions).
 * We deliberately skip SiteHeader / cookie UI / drawers to keep the iframe lean and predictable.
 */
export default function ExtensionShell({ children }) {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-50">
      {children}
      <Toaster />
    </div>
  );
}

